<template>
  <v-container>
    <h3 style="color: #312e7d; margin-bottom: 10px; margin-top: 10px">
      Catholic Health Physician Partners (Tier 1) Provider Directory
    </h3>
    <v-layout row wrap>
      <v-flex>
        <v-card>
          <v-tabs v-model="tab" centered fixed-tabs icons-and-text background-color="#4d9bcb" color="#312E7D" slider-color="#312E7D" dark @change="clearFields">
            <v-tab href="#tab-1">
              Specialty
              <i class="fas fa-stethoscope"></i>
            </v-tab>
            <v-tab href="#tab-3">
              Name
              <i class="fas fa-user-md"></i>
            </v-tab>
            <v-tab href="#tab-4">
              Practice
              <i class="fas fa-clinic-medical"></i>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-card flat>
                <v-card-text>
                  <v-autocomplete
                    v-model="searchItem"
                    ref="objSpecialty"
                    :items="autocompleteListSpecialty"
                    item-text="value"
                    item-value="npi"
                    placeholder="Speciality"
                    append-icon="magnify"
                    prepend-inner-icon="search"
                    auto-select-first
                    outlined
                    return-object
                    hide-no-data
                    :filter="filterSearchArray"
                    dense
                    hide-details
                    :error="error"
                    @change="nameSearch"
                    @keydown="captureEnterKey"
                  ></v-autocomplete>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-card flat>
                <v-card-text>
                  <v-autocomplete
                    v-model="searchItem"
                    ref="objName"
                    :items="autocompleteListName"
                    item-text="value"
                    item-value="npi"
                    placeholder="Name"
                    append-icon="magnify"
                    prepend-inner-icon="search"
                    auto-select-first
                    outlined
                    return-object
                    hide-no-data
                    :filter="filterSearchArray"
                    :error="error"
                    dense
                    hide-details
                    @change="nameSearch"
                    @keydown="captureEnterKey"
                  ></v-autocomplete>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-4">
              <v-card flat>
                <v-card-text>
                  <v-autocomplete
                    v-model="searchItem"
                    ref="objPractice"
                    :items="autocompleteListPractice"
                    item-text="value"
                    item-value="npi"
                    placeholder="Practice"
                    append-icon="magnify"
                    prepend-inner-icon="search"
                    auto-select-first
                    outlined
                    return-object
                    hide-no-data
                    :filter="filterSearchArray"
                    :error="error"
                    dense
                    hide-details
                    @change="nameSearch"
                    @keydown="captureEnterKey"
                  ></v-autocomplete>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-row>
            <div style="margin-left: 30px; font-size: 12px">Optional</div>
          </v-row>
          <v-row cols="12">
            <v-divider style="margin-left: 30px; margin-right: 30px; margin-bottom: 5px"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="2" style="margin-left: 16px; padding-top: 0px">
              <v-combobox hide-details dense v-model="searchLocation" items_notused="locationList" placeholder="Zip Code" outlined clearable append-icon>
                <template slot="item" slot-scope="data">
                  <v-icon>near_me</v-icon>
                  {{ data.item }}
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="2" style="padding-top: 0px">
              <v-combobox
                dense
                hide-details
                v-model="searchLocationRange"
                :item-value="locationRangeList.value"
                :item-text="locationRangeList.text"
                :items="locationRangeList"
                placeholder="Zip Code Within"
                outlined
              ></v-combobox>
            </v-col>
            <v-col cols="2" offset="1" style="padding-top: 0px">
              <v-combobox hide-details dense v-model="searchGender" :item-text="genderList.text" :items="genderList" placeholder="Gender" outlined></v-combobox>
            </v-col>
            <!-- <v-col cols="3" style="padding-top:0px;">
              <v-checkbox
                v-model="searchStatVisits"
                label="Stat Visits Accepted"
                dense
                hide-details
              ></v-checkbox>
            </v-col>-->
          </v-row>

          <v-btn ref="btnSearch" @click="search" class="chs-button chs-color">Search</v-btn>
        </v-card>
      </v-flex>
    </v-layout>
    <div v-if="displayResults">
      <v-layout row wrap>
        <div style="color: rgba(36, 32, 44, 0.5); margin-bottom: 15px">Search Results: {{ selectedItems.length }} record(s) found.</div>
      </v-layout>
      <v-layout row wrap v-for="provider in selectedItems" v-bind:key="provider.npi" class="mb-5 pa-3 provider-row">
        <v-col cols="12" sm="12" md="6" class="content-container">
          <h3 @click="showProvider(provider.NPI)" class="link">
            {{ provider.Prov_Name + ", " + provider.Degree }}
            <v-btn small color="#49157c" dark>VIEW FULL BIO</v-btn>
          </h3>
          <div class="mb-3">{{ provider.Speciality }}</div>
          <h4>Hospital Affiliations</h4>
          <div v-if="provider.Hospital_Affiliations == null" style="margin-bottom: 50px"></div>
          <div v-for="(aff, index) in provider.Hospital_Affiliations" v-bind:key="index">
            <div v-if="index === Object.keys(provider.Hospital_Affiliations).length - 1" style="margin-bottom: 50px">
              {{ aff.Hospital_Name }}
            </div>
            <div v-else>{{ aff.Hospital_Name }}</div>
          </div>
          <div class="content-bottom" v-if="provider.Provider_Type.toLowerCase() === 'captive'" align-center>
            <v-img alt="CHSLI Logo" class="shrink mr-2" contain src="https://www.chsli.org/themes/custom/chsli/logo.png" transition="scale-transition" width="100" style="float: left" />
            <span class="employed">CHS Physician Partners Medical Group</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-img class="results" contain height="auto" width="150" v-bind:src="`${imagePath}/${provider.NPI}.jpg`"></v-img>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div v-for="(address, index) in provider.Location" v-bind:key="index">
            <v-card v-if="index === 0 || showLocation(provider.NPI)" :key="refreshKey" style="margin-bottom: 5px">
              <v-card-text>
                <div>{{ address.Practice }}</div>
                <div>{{ address.Address }}</div>
                <div>
                  {{ address.City + ", " + address.State + " " + address.Zip }}
                </div>
                <div v-if="address.Phone">
                  <span class="material-icons" style="vertical-align: middle">call</span>
                  {{ address.Phone }}
                </div>
                <div v-if="address.Fax">
                  <span class="material-icons" style="vertical-align: middle">print</span>
                  {{ address.Fax }}
                </div>
                <div v-if="address.range" class="link" style="margin-top: 5px" @click="showMap(`${address.Address} ${address.Zip}`)">
                  <u>
                    <span class="material-icons" style="vertical-align: middle">location_on</span>
                    {{ address.range }} miles away
                  </u>
                </div>
              </v-card-text>
            </v-card>
            <div v-if="provider.Location.length > 1 && index === provider.Location.length - 1">
              <!-- <v-btn text small @click="toggleLocations(provider.NPI, provider.Location.length)"> -->
              <v-btn v-if="provider.NPI != locationNpiToShow" text small @click="toggleLocation(provider.NPI, provider.Location.length)">
                Show All Locations
                <span class="material-icons">keyboard_arrow_down</span>
              </v-btn>
              <v-btn v-if="provider.NPI === locationNpiToShow" text small @click="toggleLocation('')">
                Hide All Locations
                <span class="material-icons">keyboard_arrow_up</span>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-layout>
      <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop">
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>
    <!-- GmapMap needed so i can use gecode in code -->
    <GmapMap ref="gmap" :center="{ lat: 10, lng: 10 }" :zoom="15" map-type-id="roadmap" style="width: 0px; height: 0px"></GmapMap>
  </v-container>
</template>

<script>
import router from "../router";
import { gmapApi } from "vue2-google-maps";
import fullConfig from "../config";

const Config = fullConfig[process.env.NODE_ENV];

export default {
  name: "CHSoogle",
  data: () => {
    return {
      refreshKey: 0,
      fab: false,
      tab: null,
      selectedItems: [
        {
          lastname: null,
          firstname: null,
          title: null,
          specialty: null,
        },
      ],
      searchItem: { NPI: null, value: null },
      searchLocation: null,
      searchLocationRange: null,
      searchGender: null,
      searchStatVisits: null,
      displayResults: false,
      hidden: true,
      locationNpiToShow: "",
      locationList: ["Current Location"],
      locationRangeList: [
        { value: 5, text: "5 Miles" },
        { value: 15, text: "15 Miles" },
        { value: 25, text: "25 Miles" },
        { value: 50, text: "50 Miles" },
      ],
      genderList: [
        { abbr: "F", text: "Female" },
        { abbr: "M", text: "Male" },
        { abbr: "No Preference", text: "No Preference" },
      ],
      imagePath: Config.imageUrl,
      error: false,
      errorMessage: "",
      errowShow: false,
    };
  },
  computed: {
    google: gmapApi,
    providerData: function() {
      return this.$store.getters.PROVIDER_LIST;
    },
    autocompleteList: function() {
      return this.$store.getters.AUTOCOMPLETE_LIST;
    },
    autocompleteListSpecialty: function() {
      return this.autocompleteList.filter((el) => el.specialty);
    },
    autocompleteListName: function() {
      return this.autocompleteList.filter((el) => el.NPI);
    },
    autocompleteListPractice: function() {
      return this.autocompleteList.filter((el) => el.practice);
    },
  },
  watch: {},
  methods: {
    setFocus: function() {
      const tmp = document.getElementsByClassName("v-tab--active");
      if (tmp[0].innerText.indexOf("SPECIALTY") >= 0) {
        this.$refs.objSpecialty.focus();
      } else if (tmp[0].innerText.indexOf("NAME") >= 0) {
        this.$refs.objName.focus();
      } else if (tmp[0].innerText.indexOf("PRACTICE") >= 0) {
        this.$refs.objPractice.focus();
      }
      this.error = true;
    },
    clearFields: function() {
      this.error = false;
      this.searchLocation = "";
      this.searchLocationRange = "";
      this.searchGender = "";
      this.searchStatVisits = "";
      this.searchItem = { NPI: null, value: null };
    },
    captureEnterKey: function(event, element) {
      if (event.key === "Enter") {
        this.$refs.btnSearch.$el.focus();
      }
      this.error = false;
    },
    showProvider: function(selectedNpi) {
      router.push({ name: "provider", params: { npi: selectedNpi } });
    },
    filterSearchArray: function(obj, qText, iText) {
      // filter the search box of provider names and practices as they type
      if (obj.header || obj.divider) {
        return true;
      }
      if (obj.NPI && obj.value.toLowerCase().includes(qText.toLowerCase())) {
        return true;
      }
      if ((obj.specialty || obj.practice) && obj.value.toLowerCase().includes(qText.toLowerCase())) {
        return true;
      }
    },
    filterNames: function(item) {
      // find the object(s) based on whats in the name/specialty/practice search box
      if (item.NPI) {
        return this.providerData.filter((obj) => obj.NPI == item.NPI);
      }

      if (item.specialty) {
        return this.providerData.filter((obj) => obj.Speciality.includes(item.value));
      }

      if (item.practice) {
        return this.providerData.filter((obj) =>
        {
          if (obj.Location) {
            return obj.Location.some((loc) => loc.Practice === this.searchItem.value)
          }
        });
      }

      return Array.from(this.providerData); // all records
    },
    nameSearch: function(sel) {
      if (sel.NPI) {
        this.selectedItems = this.providerData.filter((obj) => obj.NPI == sel.NPI);
        this.displayResults = true;
      }
    },
    search: async function() {
      console.log("searching...");
      const tmp = document.getElementsByClassName("v-tab--active");
      if ((this.searchItem.value === null || this.searchItem.value === "") && tmp[0].innerText.indexOf("LOCATION") == -1) {
        console.log("not searching...");
        this.setFocus();
        return;
      }
      this.displayResults = false;

      this.selectedItems = [...this.providerData];

      // name/specialty/practice name filter
      if (this.searchItem && this.searchItem.value) {
        this.selectedItems = this.filterNames(this.searchItem);
      }

      // gender
      if (this.searchGender && this.searchGender.text != "No Preference") {
        this.selectedItems = this.selectedItems.filter((obj) => {
          if (obj.Gender) {
            return obj.Gender.toLowerCase() === this.searchGender.abbr.toLowerCase();
          }
        });
      }

      // location
      if (this.searchLocation) {
        // trying geolocation search
        let uCoords = {};

        if (this.searchLocation === "Current Location") {
          const uPos = await getPosition();

          uCoords.lat = uPos.coords.latitude;
          uCoords.lng = uPos.coords.longitude;
        } else {
          uCoords = await this.geocodeZip(this.searchLocation);
        }

        // Compute and store range
        for (let i = 0; i < this.selectedItems.length; i++) {
          if (this.selectedItems[i].Location) {
            for (let j = 0; j < this.selectedItems[i].Location.length; j++) {
              const pLoc = this.selectedItems[i].Location[j];
              if (pLoc.Latitude && pLoc.Longitude) {
                const range2 = distance(uCoords.lat, uCoords.lng, pLoc.Latitude, pLoc.Longitude, "M");
                this.selectedItems[i].Location[j].range = (Math.round(range2 * 100) / 100).toFixed(1); // Store in Location rounded to 1 decimal
              }
            }

            // sort current provider's location by range
            this.selectedItems[i].Location.sort((t1, t2) => (t1.range < t2.range ? -1 : 1));
          }
        }

        this.selectedItems = this.selectedItems.filter((item) => {
          if (item.Location) {
            for (let j = 0; j < item.Location.length; j++) {
              if (item.Location[j].range < this.searchLocationRange.value) {
                return true;
              }
            }
          }
          return false;
        });
      }

      if (this.searchLocation) {
        // sort entire provider list by range
        this.selectedItems.sort((t1, t2) => (parseFloat(t1.Location[0].range) < parseFloat(t2.Location[0].range) ? -1 : 1));
      } else {
        // sort alphabetically by provider name
        this.selectedItems.sort((t1, t2) => (t1.Prov_Name < t2.Prov_Name ? -1 : 1));
      }

      this.displayResults = true;
    },
    geocodeZip: function(zip) {
      // returns { lat: xx, lng: xx}
      return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: zip }, (res, status) => {
          if (status == "OK") {
            resolve({
              lat: res[0].geometry.location.lat(),
              lng: res[0].geometry.location.lng(),
            });
          } else {
            reject({ lat: 0, lng: 0 });
          }
        });
      });
    },
    showLocation(npi) {
      return this.locationNpiToShow === npi;
    },
    toggleLocation: function(npi, count = 1) {
      if (count <= 3) {
        this.locationNpiToShow = npi;
        this.refreshKey++;
      } else {
        this.showProvider(npi);
      }
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    showMap(addr) {
      window.open(`http://maps.google.com/maps?q=${addr}`, "_blank");
    },
  },
};

var getPosition = function(options) {
  return new Promise(function(resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
};

function distance(lat1, lon1, lat2, lon2, unit) {
  // https://www.geodatasource.com/developers/javascript
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist;
  }
}
</script>

<style>
.link {
  cursor: pointer;
}
.provider-row {
  background-color: #f1ebe5;
}
.v-input--checkbox {
  margin-top: 5px !important;
}
.v-image {
  float: right;
}
.content-container {
  position: relative;
}
.content-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.employed {
  line-height: 44px;
  font-size: 14px;
}

@media only screen and (max-width: 960px) {
  .results.v-image {
    float: left;
  }
  .content-bottom {
    position: relative;
    bottom: 0;
  }
}

@media only screen and (max-width: 600px) {
  .v-image {
    float: left;
  }
}

.chs-button {
  margin-left: 16px;
  margin-bottom: 16px;
}

.chs-color {
  background-color: #4d9bcb !important;
}

.row {
  margin: 0 -12px;
}

.v-footer--fixed {
  Position: static;
}
</style>
